import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field } from "formik";
import flowers from "../../assets/images/banner/flower_img.png";
import logo from "../../assets/images/banner/jzlogo1.png";
import { useApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../constants/endpoints";
import calendarIcon from "../../assets/images/banner/calendar-icon.svg";
import rightscroll from "../../assets/images/rightscroll.svg";
import leftscroll from "../../assets/images/leftscroll.svg";
import "./banner.css";
import * as Yup from "yup";
import Reusablebutton from "../../components/Button/Reusablebutton";
import Textarea from "../../components/Textbox/Textarea";
import InputField from "../../components/TextField/InputField";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomToast } from "../../components/Toaster/Toaster";
import LoaderModal from "../../components/Loader/LoaderModal";
import kurta from "../../assets/images/kurta.png";
import mehndidress from "../../assets/images/mehndidress.png";
import formaldress from "../../assets/images/formaldress.png";
import court from "../../assets/images/court.png";
import newquote from "../../assets/images/newquote.svg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
const RSVPValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  notes: Yup.string()
    .min(10, "Too Short!")
    .max(500, "Too Long!")
    .required("Required"),
});
const Banner = ({ params }) => {
  const scrollContainerRef = useRef(null); // Create a ref for the scroll container

  const scrollLeft = () => {
    if (scrollContainerRef.current && activeIndex > 0) {
      setActiveIndex((prevIndex) => prevIndex - 1);
      scrollContainerRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };
  
  // Scroll right to the next card
  const scrollRight = () => {
    if (scrollContainerRef.current && activeIndex < data.data.length - 1) {
      setActiveIndex((prevIndex) => prevIndex + 1);
      scrollContainerRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };
  const locationData = useLocation();
  const userData = locationData.state;
  const hash = locationData.hash;

  const bannerRef = useRef(); // Ref for the banner section
  const sendRef = useRef();
  const listViewRef = useRef();
  const audioRef = useRef(); // Ref for the audio element

  const [isPlaying, setIsPlaying] = useState(false);
  const [blockSecondRender, setBlockSecondRender] = useState(false);
  const [showMore, setShowMore] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);

  const [isMobile, setIsMobile] = useState(false);

  const { useGetQuery, usePostMutation } = useApi();
  const { mutate: postUserNote } = usePostMutation(API_ENDPOINTS.USER_NOTE);

  const formSubmitHandler = (values) => {
    setIsLoading(true);
    postUserNote(
      {
        event_uuid: null,
        user_uuid: null,
        name: values.firstName,
        note: values.notes,
      },
      {
        onSuccess: (response) => {
          setIsLoading(false);
          CustomToast("success", response.message || "Note Posted");
          FetchCallsDetailsData();
          setTimeout(() => {
            if (listViewRef.current) {
              listViewRef.current.scrollIntoView({
                behavior: "smooth",
              });
            }
          }, 100); // Delay for 100 milliseconds
        },
        onError: (error) => {
          setIsLoading(false);
          CustomToast(
            "error",
            error?.response?.data?.message ||
              "Something went wrong, please try again"
          );
        },
      }
    );
  };

  const {
    data,
    isFetching,
    refetch: FetchCallsDetailsData,
  } = useGetQuery(["get-event"], API_ENDPOINTS.GET_NOTES);

  useEffect(() => {
    if (
      (userData || hash) &&
      (userData?.event_uuid || hash === "#sendwish") &&
      (userData?.user_uuid || hash === "#sendwish") &&
      sendRef?.current &&
      !blockSecondRender &&
      !isFetching
    ) {
      sendRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (!isFetching) {
      setBlockSecondRender(true);
    }
  }, [userData, sendRef, isFetching]);

  const scrollToBanner = () => {
    if (bannerRef.current) {
      bannerRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.volume = 0.1;
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  // Slick carousel settings
  const sliderSettings = {
    initialSlide: currentCardIndex,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (oldIndex, newIndex) => setCurrentCardIndex(newIndex),
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    swipeToSlide: true, // Enable swipe on touch devices
    responsive: [
      {
        breakpoint: 768, // For mobile screens
        settings: {
          arrows: false, // No arrows on mobile
        },
      },
    ],
  };

  const openDialog = (index) => {
    setCurrentCardIndex(index);
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  useEffect(() => {
    // Check if the screen width is less than 768 pixels
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div ref={bannerRef} className="relative flex justify-center h-screen">
        <img
          src={flowers}
          alt="flowers-img"
          className="w-full absolute bottom-0"
        />
        <img
          src={logo}
          alt="logo"
          className="absolute top-6 h-[90%] opacity-70"
        />
        <div className="text-center flex justify-center items-center flex-col">
          <p className="font-[FONTSPRING] text-[20px] lg:text-[38px] text-[#492B2B]">
            Celebrating the Joy of Our Wedding
          </p>
          <p className="font-[AmsterdamThreeSlant] text-[81px] lg:text-[78px] lg:leading-[inherit] leading-[2] text-[#000000] tracking-[-7px] mt-[30px]">
            Jassir & Zainab
          </p>
          <p className="font-[FONTSPRING] text-[18px] lg:text-[32px] text-[#492B2B] mt-[36px]">
            Looking Forward to Celebrating with You
          </p>
          <p className="font-[PTSerifRegular] text-[18px] lg:text-[26px] lg:mt-14 mt-5 text-[#492B2B] tracking-[5.51px]">
            MAY
          </p>
          <div className="flex lg:gap-7 gap-4  items-center lg:flex-row flex-col">
            <p className="font-[PTSerifRegular] text-[18px] lg:text-[26px] text-[#492B2B] py-2 px-4 tracking-[5.51px] border-y-[4px] border-[#492B2B]">
              SUNDAY
            </p>
            <p className="w-[107px] font-[PTSerifRegular] text-[50px] lg:text-[88px] text-[#A66416] tracking-[17.5px] leading-[1] font-semibold">
              10
            </p>
            <p className="w-[204.94px] font-[PTSerifRegular] text-[18px] lg:text-[26px] text-[#492B2B] py-2 px-4 tracking-[5.51px] border-y-[4px] border-[#492B2B]">
              3:30 PM
            </p>
          </div>
          <p className="font-[PTSerifRegular] text-[18px] lg:text-[26px] text-[#492B2B] tracking-[5.51px]">
            2026
          </p>
        </div>
      </div>
      {/* Timeline starts here */}
      
      {/* Timeline ends here */}
     
      <div className="relative  bg-[#ffffff]">
        <div className="container mx-auto lg:p-14 p-3 ">
          <div className="flex flex-wrap gap-7 mt-10 overflow-hidden">
            <div className="max-w-[565px]">
              <p
                className="text-[#4F2532] text-[20px] lg:text-[36px] font-[CinzelDecorativeBold] mb-7"
                ref={listViewRef}
              >
                WHAT OUR LOVED ONES SAY
              </p>
              <p className="text-[#292B2D] text-[14px] lg:text-[20px] font-[AddingtonCFThin] mb-7">
                Hear heartfelt messages and cherished memories from our family
                and friends. Their love and support mean the world to us as we
                celebrate this special occasion.
              </p>
            </div>
            {data?.data &&
              data?.data?.length > 0 &&
              !isMobile &&
              data?.data?.slice(0, 8 + 4 * showMore).map((wish, index) => (
                <div
                  key={index}
                  className="lg:max-w-[258px] max-w-full bg-[#FFF4F2] p-6 flex rounded-[30px] lg:h-full h-auto flex-col"
                >
                  <p className="break-words font-[AddingtonCFThin] text-[14px] lg:text-[18px] text-[#292B2D] line-clamp-4">
                    {wish.note}
                  </p>
                  <button
                    onClick={() => openDialog(index)}
                    className="flex mb-7 font-[PTSerifRegular] text-[16px] text-[#A66416] underline cursor-pointer"
                  >
                    Read More
                  </button>

                  <div className="flex gap-4 items-center">
                    <div className="bg-[#FFFFFF] text-[#A66416] flex text-[12px] lg:text-[16px] items-center justify-center rounded-[100%] w-[48px] p-3 font-[CinzelDecorativeBold]">
                      {wish?.name?.[0]?.toUpperCase()}
                      {wish?.name?.split(" ")?.[1]?.[0]?.toUpperCase()}
                    </div>
                    <div>
                      <p className="max-w-[160px] whitespace-nowrap overflow-ellipsis overflow-hidden font-[CinzelDecorativeBold] text-[12px] lg:text-[16px] text-[#4F2532]">
                        {wish.name}
                      </p>
                    </div>
                  </div>
                </div>
              ))}

{data?.data && isMobile && data?.data?.length > 0 && (
    <div
      ref={scrollContainerRef} // Attach the ref to the scroll container
      className="flex overflow-hidden gap-4 px-4"
      style={{ scrollSnapType: "x mandatory" }} // Ensure snap behavior for smooth transitions
    >
      {data.data.map((item, index) => (
        <div
          key={index}
          className={`min-w-[300px] ${index === activeIndex ? 'block' : 'hidden'} snap-center bg-[#FFF4F2] px-[3.5rem] p-7 flex justify-between rounded-[30px] h-auto flex-col relative gap-1`}
        >
          {/* Left Scroll Icon */}
          <img
            src={leftscroll}
            alt="left-scroll"
            onClick={scrollLeft}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 h-6 w-6 cursor-pointer"
          />

          {/* Right Scroll Icon */}
          <img
            src={rightscroll}
            alt="right-scroll"
            onClick={scrollRight}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 h-6 w-6 cursor-pointer"
          />

          <div>
            <img
              src={newquote}
              alt="quote-icon"
              className="h-6 w-8 mb-4"
            />
            <p
              className="break-words font-[AddingtonCFThin] text-[14px] lg:text-[18px] text-[#292B2D]">
              {item.note}
            </p>
          </div>
          <div className="flex gap-4 items-center">
            <div className="bg-[#FFFFFF] text-[#A66416] flex text-[12px] lg:text-[16px] items-center justify-center rounded-full w-[48px] p-3 font-[CinzelDecorativeBold]">
              {item?.name?.[0]?.toUpperCase()}
              {item?.name?.split(" ")?.[1]?.[0]?.toUpperCase()}
            </div>
            <div>
              <p className="max-w-[160px] whitespace-nowrap overflow-ellipsis overflow-hidden font-[CinzelDecorativeBold] text-[12px] lg:text-[16px] text-[#4F2532]">
                {item.name}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )}

          </div>
        </div>
        {isDialogOpen && (
          <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
            <div className="lg:m-0 m-3 lg:max-w-[360px] max-w-full rounded-[30px] p-6 lg:w-1/2 w-11/12 max-h-full relative">
              {/* Close Button */}
              <button
                className="text-black text-[30px] absolute lg:top-[2.5rem] lg:right-[3.5rem] top-12 right-16 z-50"
                onClick={closeDialog}
              >
                &times;
              </button>

              {/* Carousel */}
              <Slider {...sliderSettings}>
                {data?.data?.map((wish, index) => (
                  <div key={index} className="p-4">
                    <div className="bg-[#FFF4F2] p-6 flex rounded-[30px] h-full flex-col">
                      <img
                        src={newquote}
                        alt="quote-icon"
                        className="h-6 w-8 mb-8"
                      />
                      {/* <p className="break-words font-[AddingtonCFThin] text-[14px] lg:text-[18px] text-[#292B2D] mb-7"> */}
                      <p
                        className="break-words font-[AddingtonCFThin] text-[14px] lg:text-[18px] text-[#292B2D] mb-7"
                        style={{ maxHeight: '150px', overflowY: 'auto' }}
                      >
                        {wish.note}
                      </p>
                      <div className="flex gap-4 items-center">
                        <div className="bg-[#FFFFFF] text-[#A66416] flex text-[12px] lg:text-[16px] items-center justify-center rounded-[100%] w-[48px] p-3 font-[CinzelDecorativeBold]">
                          {wish?.name?.[0]?.toUpperCase()}
                          {wish?.name?.split(" ")?.[1]?.[0]?.toUpperCase()}
                        </div>
                        <div>
                          <p className="max-w-[160px] whitespace-nowrap overflow-ellipsis overflow-hidden font-[CinzelDecorativeBold] text-[12px] lg:text-[16px] text-[#4F2532]">
                            {wish.name}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        )}
        {showMore * 4 + 8 < data?.data?.length && !isMobile && (
          <div className="flex justify-center mb-[2rem]">
            <Reusablebutton
              className="bg-[#EFB6B6] text-[13px] text-[#4F2532] rounded-[18px] !w-[auto] px-6"
              buttonLabel="Load More"
              type="submit"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowMore((state) => state + 1);
              }}
            />
          </div>
        )}
      </div>
      <div className="container mx-auto lg:p-14 p-3 !py-0">
        <div className="thanking">
          <h1
            className=" text-[#000000] cursor-pointer text-[73px] mt-20 text-center"
            style={{ fontFamily: "AmsterdamThreeSlant" }}
          >
            thank you-
          </h1>
        </div>
        <div className="flex justify-center items-center h-[50%] ">
          <div className="sub-area pt-[4rem]">
            <h1
              className="top-heading text-[#4F2532]"
              style={{ fontFamily: "bold" }}
            >
              send your wishes to the couple
            </h1>
            {(isLoading || isFetching) && <LoaderModal />}
            <Formik
              initialValues={{
                firstName: "",
                notes: "",
              }}
              validationSchema={RSVPValidationSchema}
              onSubmit={(values, { resetForm }) => {
                formSubmitHandler(values);
                resetForm(); // Clear fields immediately after submission
              }}
            >
              {({ errors, touched }) => (
                <Form className="form-grp">
                  <div className="pt-5">
                    <Field
                      name="firstName"
                      placeholder="Your Name"
                      component={InputField}
                    />
                  </div>

                  <div className="pt-5">
                    <Field
                      name="notes"
                      placeholder="Your Notes"
                      component={Textarea}
                      error={
                        errors.notes && touched.notes ? errors.notes : undefined
                      }
                    />
                  </div>

                  <Reusablebutton
                    className="bg-[#EFB6B6] text-[13px] text-[#4F2532] rounded-[18px] send-btn"
                    buttonLabel="Send"
                    type="submit"
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <section id="sendwish">
          <div ref={sendRef}></div>
        </section>{" "}
        <div className="text-center mt-12">
          <h1
            className="text-[24px] text-[#292B2D] cursor-pointer text-[PTSerif]"
            style={{ fontFamily: "thin" }}
            onClick={scrollToBanner}
          >
            We are excited to share this significant milestone in our lives with
            you. <br />
            We look forward to celebrating together and creating cherished{" "}
            <br />
            <span className="block text-center">
              memories, surrounded by our beloved ones.
            </span>
          </h1>
          <h1
            className="text-[34px] text-[#4F2532] cursor-pointer mb-9 mt-6"
            onClick={scrollToBanner}
          ></h1>
        </div>
      </div>
      <div className="">
        <footer
          className="bg-[#FCEFEB] text-[#292B2D] py-4 font-bold"
          style={{ fontFamily: "thin" }}
        >
          <div className="container mx-auto text-center">
            #jz4life
          </div>
        </footer>
      </div>
    </>
  );
};

export default Banner;

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "rgb(239 182 182)" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "rgb(239 182 182)",
        color: "black",
      }}
      onClick={onClick}
    />
  );
}
